import React from 'react'
import { About, Contact, Footer, Header, Skills, Testimonials, Work } from "./containers";
import { NavBar } from "./components/";
import './App.scss';
import Services from './containers/Services/Services';
const App = () => {
  return (
    <>
      <NavBar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Services/>
      <Testimonials />
      <Contact/>
      <Footer />
    </>
  )
};

export default App;
